document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  if (menuButton && mobilePanel) {
    menuButton.addEventListener('click', () => {
      const open = mobilePanel.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const next = thumb.getAttribute('data-image-src');
        if (!main || !next) return;
        main.src = next;
        gallery.querySelectorAll('[data-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-skin-section]').forEach((section) => {
    const input = section.querySelector('[data-skin-search]');
    const cards = [...section.querySelectorAll('[data-skin-card]')];
    const counter = section.querySelector('[data-skin-count]');
    if (!input) return;
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const matches = !query || card.textContent.toLowerCase().includes(query);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (counter) counter.textContent = `${visible} shown`;
    });
  });

  document.querySelectorAll('[data-buy-scroll]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector('[data-product-form]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  const inventoryDrawer = document.querySelector('[data-inventory-drawer]');
  const inventoryBackdrop = document.querySelector('[data-inventory-backdrop]');
  const inventoryClose = inventoryDrawer?.querySelector('[data-inventory-close]');
  const inventoryTitle = inventoryDrawer?.querySelector('[data-inventory-drawer-title]');
  const inventoryCount = inventoryDrawer?.querySelector('[data-inventory-drawer-count]');
  let inventoryOpener = null;

  const closeInventory = () => {
    if (!inventoryDrawer || !inventoryBackdrop) return;
    inventoryDrawer.classList.remove('is-open');
    inventoryDrawer.setAttribute('aria-hidden', 'true');
    inventoryBackdrop.hidden = true;
    document.body.classList.remove('polr-drawer-open');
    document.querySelectorAll('[data-inventory-trigger]').forEach((item) => item.setAttribute('aria-expanded', 'false'));
    const restoreTarget = inventoryOpener;
    inventoryOpener = null;
    window.setTimeout(() => restoreTarget?.focus(), 0);
  };

  document.querySelectorAll('[data-inventory-trigger]').forEach((trigger) => {
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', () => {
      if (!inventoryDrawer || !inventoryBackdrop) return;
      const category = trigger.getAttribute('data-inventory-trigger');
      const panel = inventoryDrawer.querySelector(`[data-inventory-panel="${category}"]`);
      if (!panel) return;
      inventoryDrawer.querySelectorAll('[data-inventory-panel]').forEach((item) => { item.hidden = item !== panel; });
      if (inventoryTitle) inventoryTitle.textContent = trigger.getAttribute('data-inventory-title') || 'Inventory';
      if (inventoryCount) {
        const count = Number.parseInt(trigger.getAttribute('data-inventory-count') || '0', 10);
        inventoryCount.textContent = `${Number.isFinite(count) ? count : 0} items`;
      }
      inventoryOpener = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      inventoryBackdrop.hidden = false;
      inventoryDrawer.classList.add('is-open');
      inventoryDrawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('polr-drawer-open');
      window.requestAnimationFrame(() => inventoryClose?.focus());
    });
  });

  inventoryClose?.addEventListener('click', closeInventory);
  inventoryBackdrop?.addEventListener('click', closeInventory);
  inventoryDrawer?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeInventory();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...inventoryDrawer.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((item) => !item.closest('[hidden]'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
});
